@if (loading===false){
<div class="container">
	<div class="user-details">
		<h3>{{user ? 'Edit' : 'Add'}} User Details</h3>
		<form [formGroup]="validations_form">
			<mat-form-field>
				<mat-label>Name</mat-label>
				<input matInput type="text" formControlName="nameControl">
			</mat-form-field>
			<ng-container *ngFor="let validation of validation_messages.nameControl">
				<div class="validation-error-message" *ngIf="
						validations_form.get('nameControl').hasError(validation.type) &&
						(validations_form.get('nameControl').dirty ||
							validations_form.get('nameControl').touched)
					">
					{{ validation.message }}
				</div>
			</ng-container>
			<mat-form-field>
				<mat-label>Surname</mat-label>
				<input matInput type="text" formControlName="surnameControl">
			</mat-form-field>
			<ng-container *ngFor="let validation of validation_messages.surnameControl">
				<div class="validation-error-message" *ngIf="
						validations_form.get('surnameControl').hasError(validation.type) &&
						(validations_form.get('surnameControl').dirty ||
							validations_form.get('surnameControl').touched)
					">
					{{ validation.message }}
				</div>
			</ng-container>
			<mat-form-field>
				<mat-label>Email</mat-label>
				<input matInput type="text" formControlName="emailControl">
			</mat-form-field>
			<ng-container *ngFor="let validation of validation_messages.emailControl">
				<div class="validation-error-message" *ngIf="
						validations_form.get('emailControl').hasError(validation.type) &&
						(validations_form.get('emailControl').dirty ||
							validations_form.get('emailControl').touched)
					">
					{{ validation.message }}
				</div>
			</ng-container>
			<div class="validation-error-message" *ngIf="
					validations_form.get('emailControl').hasError('duplicate') &&
					(validations_form.get('emailControl').dirty ||
						validations_form.get('emailControl').touched)
				">
				Email should be unique
			</div>
		</form>
		<app-user-role-tree *ngIf="user != null || userID == 0" [preSelected]="user != null ? user.UserAccessRoles : []"
			(selectedRolesEmitter)="updateUserRoles($event)"></app-user-role-tree>
	</div>
	<div class="user-accesses">
		<h3>{{user ? 'Edit' : 'Add'}} User Accesses</h3>
		<div class="diplayTable" *ngIf="dataAccesses">

			<ng-template #prefixTemplate let-row>
				<app-card-table-actions [row]="row" (actionEvent)="entitySelected($event)"
					[breakpoint]="ScreenSize.TABLET" [makeCheckbox]="true"></app-card-table-actions>
			</ng-template>

			<ng-template #affixTemplate let-row>
				<app-card-table-actions style="margin-left: 20px;" [row]="row"
					(actionEvent)="subCustomerSelected($event)" [makeToggle]="true"
					toggleTitle="Add sub customers"></app-card-table-actions>
			</ng-template>

			<app-card-table #Customers [data]="dataAccesses.Customers" [currentPage]="currentCustomerPage"
				*ngIf="!aggregatesToggled && dataAccesses.Customers.length > 0" [totalItems]="10"
				[options]="cdrTableOptions" [enableInfiteScroll]="false" [enableTablePagination]="true"
				[affixTemplate]="affixTemplate" [prefixTemplate]="prefixTemplate" (dataScrolledEvent)="(null)"
				(paginateEvent)="(null)" [breakpoint]="ScreenSize.TABLET" [enableRefresher]="true"
				(dataRefreshedEvent)="(null)" [tableHeaders]="customerHeaders" [originalStyling]="false"
				[isExpandable]="false">
			</app-card-table>
			<div>
				<p *ngIf="!aggregatesToggled && dataAccesses.Customers.length == 0">No customers to display</p>
			</div>


			<ng-template #prefixTemplate let-row>
				<app-card-table-actions [row]="row" (actionEvent)="entitySelected($event)"
					[breakpoint]="ScreenSize.TABLET" [makeCheckbox]="true"></app-card-table-actions>
			</ng-template>

			<app-card-table #Aggregates [data]="dataAccesses.Aggregates" [currentPage]="currentCustomerPage"
				*ngIf="aggregatesToggled && dataAccesses.Aggregates.length > 0" [totalItems]="10"
				[options]="cdrTableOptions" (rowSelectedEvent)="(null)" [enableInfiteScroll]="false"
				[enableTablePagination]="true" [prefixTemplate]="prefixTemplate" (dataScrolledEvent)="(null)"
				(paginateEvent)="(null)" [breakpoint]="ScreenSize.TABLET" [enableRefresher]="true"
				(dataRefreshedEvent)="(null)" [tableHeaders]="aggregateHeaders" [originalStyling]="false"
				[isExpandable]="false">
			</app-card-table>
			<div>
				<p *ngIf="aggregatesToggled && dataAccesses.Aggregates.length == 0">No aggregates to display</p>
			</div>
		</div>
	</div>
</div>

<div class="buttons">
	<button class="cancel" mat-button (click)="cancel()">Cancel</button>
	<button class="save" mat-button (click)="addUser()">{{user ? 'Save' : 'Add'}} User</button>
</div>
}@else {
<div class="loading">
	<mat-spinner diameter="50"></mat-spinner>
</div>
}